import React, { useState } from "react";

export default function VenteCard({ sales, distributeurs = [] }) {
  const [selectedDistributeur, setSelectedDistributeur] = useState("all");

  const filtered = sales.filter((s) =>
    selectedDistributeur === "all" || s.distributeur_id === selectedDistributeur
  );

  // Helper function to get display name from distributeur ID
  const getDistributeurName = (id) => {
    const dist = distributeurs.find(d => d.id === id);
    return dist ? (dist.display_name || dist.id) : id;
  };

  return (
    <div style={{ background: "#fff", borderRadius: 16, padding: "1.5rem", marginBottom: "1.5rem", boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1.25rem" }}>
        <h2 style={{ margin: 0, fontSize: "1rem", fontWeight: 700, color: "#1e293b" }}>Ventes récentes</h2>
        <select
          value={selectedDistributeur}
          onChange={(e) => setSelectedDistributeur(e.target.value)}
          style={{
            padding: "0.4rem 0.8rem", fontSize: "0.82rem", border: "1px solid #e2e8f0",
            borderRadius: 8, outline: "none", color: "#374151", cursor: "pointer",
          }}
        >
          <option value="all">Tous les distributeurs</option>
          {distributeurs && distributeurs.map((d) => (
            <option key={d.id} value={d.id}>
              {d.display_name || d.id}
            </option>
          ))}
        </select>
      </div>

      {filtered.length === 0 ? (
        <p style={{ color: "#94a3b8", fontSize: "0.85rem", margin: 0 }}>Aucune vente</p>
      ) : (
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {["Distributeur", "Boisson", "Taille", "Sirop", "Date"].map((h) => (
                <th key={h} style={{ textAlign: "left", padding: "0.5rem 0.75rem", fontSize: "0.72rem", fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.5, borderBottom: "1px solid #f1f5f9" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.map((s, i) => (
              <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#f8fafc" }}>
                <td style={{ padding: "0.6rem 0.75rem", fontSize: "0.85rem", color: "#1e293b", fontWeight: 600 }}>
                  {getDistributeurName(s.distributeur_id)}
                </td>
                <td style={{ padding: "0.6rem 0.75rem", fontSize: "0.85rem", color: "#374151" }}>{s.drink_name}</td>
                <td style={{ padding: "0.6rem 0.75rem", fontSize: "0.85rem", color: "#374151" }}>{s.size} ml</td>
                <td style={{ padding: "0.6rem 0.75rem", fontSize: "0.85rem", color: "#374151" }}>{s.syrop_size} ml</td>
                <td style={{ padding: "0.6rem 0.75rem", fontSize: "0.82rem", color: "#94a3b8" }}>
                  {new Date(s.timestamp).toLocaleDateString('fr-FR', {
                    day: '2-digit',
                    month: '2-digit',
                    year: 'numeric'
                  })} {new Date(s.timestamp).toLocaleTimeString('fr-FR', {
                    hour: '2-digit',
                    minute: '2-digit'
                  })}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
